// category: 'rental' = jen pronájem, 'accommodation' = jen ubytování, 'both' = sdílené
import { trans } from 'laravel-vue-i18n'

export function useRentalItemTypes() {
    const rentalItemTypes = [
        {
            type: 'apartment',
            name: trans('rental.item_type_apartment'),
            category: 'accommodation',
            icon: 'pi pi-home',
            defaultAttributes: [
                { label: trans('rental.attr_bed_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_private_bathroom'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: 'Wi-Fi', value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: 'TV', value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'room',
            name: trans('rental.item_type_room'),
            category: 'accommodation',
            icon: 'pi pi-home',
            defaultAttributes: [
                { label: trans('rental.attr_bed_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_private_bathroom'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: 'Wi-Fi', value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: 'TV', value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'cabin',
            name: trans('rental.item_type_cabin'),
            category: 'accommodation',
            icon: 'pi pi-home',
            defaultAttributes: [
                { label: trans('rental.attr_room_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_kitchenette'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_shower'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_toilet'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_heating'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'van',
            name: trans('rental.item_type_van'),
            category: 'both',
            icon: 'pi pi-truck',
            defaultAttributes: [
                { label: trans('rental.attr_sleep_inside'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_consumption'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_length_m'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'tent',
            name: trans('rental.item_type_tent'),
            category: 'both',
            icon: 'pi pi-image',
            defaultAttributes: [
                { label: trans('rental.attr_person_capacity'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_water_column'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_bedroom_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'hot_tub',
            name: trans('rental.item_type_hot_tub'),
            category: 'both',
            icon: 'pi pi-globe',
            defaultAttributes: [
                { label: trans('rental.attr_person_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_filtration'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_mobile_hot_tub'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'car',
            name: trans('rental.item_type_car'),
            category: 'rental',
            icon: 'pi pi-car',
            defaultAttributes: [
                { label: trans('rental.attr_gearbox'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_fuel'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_seat_count'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_color'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_license_plate'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
            ]
        },
        {
            type: 'bike',
            name: trans('rental.item_type_bike'),
            category: 'rental',
            icon: 'pi pi-compass',
            defaultAttributes: [
                { label: trans('rental.attr_frame_type'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_frame_size'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_electric'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
            ]
        },
        {
            type: 'sports_court',
            name: trans('rental.item_type_sports_court'),
            category: 'rental',
            icon: 'pi pi-users',
            defaultAttributes: [
                { label: trans('rental.attr_surface_type'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_lighting'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_person_capacity'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'projector',
            name: trans('rental.item_type_projector'),
            category: 'rental',
            icon: 'pi pi-video',
            defaultAttributes: [
                { label: trans('rental.attr_resolution'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_brightness_lm'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_hdmi_input'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'tool',
            name: trans('rental.item_type_tool'),
            category: 'rental',
            icon: 'pi pi-wrench',
            defaultAttributes: [
                { label: trans('rental.attr_tool_type'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_power_w'), value_type: 'number', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_power_supply'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
        {
            type: 'bouncy_castle',
            name: trans('rental.item_type_bouncy_castle'),
            category: 'rental',
            icon: 'pi pi-star',
            defaultAttributes: [
                { label: trans('rental.attr_dimensions'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_suitable_age'), value_type: 'string', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' },
                { label: trans('rental.attr_blower_included'), value_type: 'boolean', is_highlighted: false, is_visible: true, color: '#000000', note: '', icon: 'pi pi-star', value: '' }
            ]
        },
    ];

    return { rentalItemTypes }
}
